import React from "react";

import { WORKER_SOLUTIONS } from "../../constants";
import SolutionCard from "../../SolutionCard";
import useHorizontalScrollAnimation from "./useHorizontalScrollAnimation";

import * as S from "./styles";

function TailoredSolutionsContentDesktop() {
  const { scrollContainerRef, targetRef, scrollContainerHeight, x } =
    useHorizontalScrollAnimation();

  return (
    <div
      ref={scrollContainerRef}
      style={{
        height: `${scrollContainerHeight}px`,
        position:
          "relative" /* Added position relative to fix Framer Motion warning */,
        overflow:
          "visible" /* Added to ensure heading visibility at all times */,
      }}
    >
      <S.StyledSection ref={targetRef}>
        <S.HeadingContainer>
          <S.Heading>
            How Reach solves the toughest challenges{" "}
            <S.HeadingHighlight>
              for every member of your campaign team{" "}
              <S.HeadingHighlightDot
                src="/images/icons/dot-grey.svg"
                alt="dot"
              />
            </S.HeadingHighlight>
          </S.Heading>
        </S.HeadingContainer>
        <S.CardsContainer style={{ x }}>
          {WORKER_SOLUTIONS.map((solution, index) => (
            <SolutionCard
              key={solution.id}
              isLast={index === WORKER_SOLUTIONS.length - 1}
              {...solution}
            />
          ))}
        </S.CardsContainer>
      </S.StyledSection>
    </div>
  );
}

export default TailoredSolutionsContentDesktop;
